<template>
  <v-widget
    :title="$t('Password Settings')"
    class="mb-4"
  >
    <div slot="widget-content">
      <CustomerNewPasswordForm :customer="customer"/>
    </div>
  </v-widget>
</template>

<script>
import CustomerNewPasswordForm from '../CustomerNew/CustomerNewPasswordForm'

export default {
  name: 'CustomerNewPassword',

  components: {
    CustomerNewPasswordForm
  },

  props: {
    customer: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      menu: false
    }
  }
}
</script>
